import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { PersonArch } from 'src/entities/organization/Person';
import { action } from 'src/store/actions';

/*  Direct Customers  */
export const FETCH_DIRECT_CUSTOMERS = 'FETCH_DIRECT_CUSTOMERS';
export const REQUEST_DIRECT_CUSTOMERS = 'REQUEST_DIRECT_CUSTOMERS';
export const SUCCESS_DIRECT_CUSTOMERS = 'SUCCESS_DIRECT_CUSTOMERS';
export const FAILURE_DIRECT_CUSTOMERS = 'FAILURE_DIRECT_CUSTOMERS';

export const fetchDirectCustomers = () => action(FETCH_DIRECT_CUSTOMERS);
export const requestDirectCustomers = () => action(REQUEST_DIRECT_CUSTOMERS);
export const requestDirectCustomersSuccess = (response: any) => action(SUCCESS_DIRECT_CUSTOMERS, { response });
export const requestDirectCustomersFailure = (error: any) => action(FAILURE_DIRECT_CUSTOMERS, { error });

/*  Success List Overview  */
export const FETCH_SUCCESS_LIST_OVERVIEW = 'FETCH_SUCCESS_LIST_OVERVIEW';
export const REQUEST_SUCCESS_LIST_OVERVIEW = 'REQUEST_SUCCESS_LIST_OVERVIEW';
export const SUCCESS_SUCCESS_LIST_OVERVIEW = 'SUCCESS_SUCCESS_LIST_OVERVIEW';
export const FAILURE_SUCCESS_LIST_OVERVIEW = 'FAILURE_SUCCESS_LIST_OVERVIEW';

export const fetchSuccessListOverview = () => action(FETCH_SUCCESS_LIST_OVERVIEW);
export const requestSuccessListOverview = () => action(REQUEST_SUCCESS_LIST_OVERVIEW);
export const requestSuccessListOverviewSuccess = (response: any) => action(SUCCESS_SUCCESS_LIST_OVERVIEW, { response });
export const requestSuccessListOverviewFailure = (error: any) => action(FAILURE_SUCCESS_LIST_OVERVIEW, { error });

/* Success List Topics */
export const FETCH_SUCCESS_LIST_TOPICS = 'FETCH_SUCCESS_LIST_TOPICS';
export const REQUEST_SUCCESS_LIST_TOPICS = 'REQUEST_SUCCESS_LIST_TOPICS';
export const SUCCESS_SUCCESS_LIST_TOPICS = 'SUCCESS_SUCCESS_LIST_TOPICS';
export const FAILURE_SUCCESS_LIST_TOPICS = 'FAILURE_SUCCESS_LIST_TOPICS';

export const fetchSuccessListTopics = () => action(FETCH_SUCCESS_LIST_TOPICS);
export const requestSuccessListTopics = () => action(REQUEST_SUCCESS_LIST_TOPICS);
export const requestSuccessListTopicsSuccess = (response: any) => action(SUCCESS_SUCCESS_LIST_TOPICS, { response });
export const requestSuccessListTopicsFailure = (error: any) => action(FAILURE_SUCCESS_LIST_TOPICS, { error });

/* Success List by topic */
export const FETCH_SUCCESS_LIST = 'FETCH_SUCCESS_LIST';
export const REQUEST_SUCCESS_LIST = 'REQUEST_SUCCESS_LIST';
export const SUCCESS_SUCCESS_LIST = 'SUCCESS_SUCCESS_LIST';
export const FAILURE_SUCCESS_LIST = 'FAILURE_SUCCESS_LIST';

export const fetchSuccessList = (topic: string, pageable?: PageableQueryParams, personArch?: PersonArch) =>
    action(FETCH_SUCCESS_LIST, { topic, pageable, personArch });
export const requestSuccessList = () => action(REQUEST_SUCCESS_LIST);
export const requestSuccessListSuccess = (response: any) => action(SUCCESS_SUCCESS_LIST, { response });
export const requestSuccessListFailure = (error: any) => action(FAILURE_SUCCESS_LIST, { error });

/* Success List by topic */
export const FETCH_SUCCESS_LIST_ENTRY_HISTORY = 'FETCH_SUCCESS_LIST_ENTRY_HISTORY';
export const REQUEST_SUCCESS_LIST_ENTRY_HISTORY = 'REQUEST_SUCCESS_LIST_ENTRY_HISTORY';
export const SUCCESS_SUCCESS_LIST_ENTRY_HISTORY = 'SUCCESS_SUCCESS_LIST_ENTRY_HISTORY';
export const FAILURE_SUCCESS_LIST_ENTRY_HISTORY = 'FAILURE_SUCCESS_LIST_ENTRY_HISTORY';

export const fetchSuccessListEntryHistory = (nameListEntryId: string) =>
    action(FETCH_SUCCESS_LIST_ENTRY_HISTORY, { nameListEntryId });
export const requestSuccessListEntryHistory = () => action(REQUEST_SUCCESS_LIST_ENTRY_HISTORY);
export const requestSuccessListEntryHistorySuccess = (response: any) =>
    action(SUCCESS_SUCCESS_LIST_ENTRY_HISTORY, { response });
export const requestSuccessListEntryHistoryFailure = (error: any) =>
    action(FAILURE_SUCCESS_LIST_ENTRY_HISTORY, { error });

/* Success List Regions */
export const FETCH_SUCCESS_LIST_REGIONS = 'FETCH_SUCCESS_LIST_REGIONS';
export const REQUEST_SUCCESS_LIST_REGIONS = 'REQUEST_SUCCESS_LIST_REGIONS';
export const SUCCESS_SUCCESS_LIST_REGIONS = 'SUCCESS_SUCCESS_LIST_REGIONS';
export const FAILURE_SUCCESS_LIST_REGIONS = 'FAILURE_SUCCESS_LIST_REGIONS';

export const fetchSuccessListRegions = () => action(FETCH_SUCCESS_LIST_REGIONS);
export const requestSuccessListRegions = () => action(REQUEST_SUCCESS_LIST_REGIONS);
export const requestSuccessListRegionsSuccess = (response: any) => action(SUCCESS_SUCCESS_LIST_REGIONS, { response });
export const requestSuccessListRegionsFailure = (error: any) => action(FAILURE_SUCCESS_LIST_REGIONS, { error });
